var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIconSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4781 15.3904C18.4032 14.3156 17.1239 13.5199 15.728 13.0382C17.223 12.0086 18.2052 10.2853 18.2052 8.33677C18.2052 5.19094 15.6458 2.63159 12.5 2.63159C9.35418 2.63159 6.79483 5.19094 6.79483 8.33677C6.79483 10.2853 7.77701 12.0086 9.27204 13.0382C7.87619 13.5199 6.59685 14.3156 5.522 15.3904C3.84083 17.0716 2.84091 19.2525 2.66101 21.5982C2.62845 22.0227 2.97677 22.3684 3.40256 22.3684C3.82836 22.3684 4.16979 22.0221 4.20886 21.5981C4.59879 17.3666 8.16844 14.042 12.5 14.042C16.8316 14.042 20.4012 17.3666 20.7912 21.5981C20.8302 22.0221 21.1717 22.3684 21.5975 22.3684C22.0233 22.3684 22.3716 22.0227 22.339 21.5982C22.1591 19.2525 21.1592 17.0716 19.4781 15.3904ZM12.5 12.5C10.2044 12.5 8.33677 10.6324 8.33677 8.33677C8.33677 6.04113 10.2044 4.17353 12.5 4.17353C14.7956 4.17353 16.6633 6.04113 16.6633 8.33677C16.6633 10.6324 14.7956 12.5 12.5 12.5Z",
    fill: "#2B2526",
    stroke: "#2B2526",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconSingle);
export default __webpack_public_path__ + "static/media/userIconSingle.96cc90dc5d1616db7cc20bdb6798c5aa.svg";
export { ForwardRef as ReactComponent };